/**
 * Browser-specific scenario loading
 * Uses esbuild imports to handle .raw files
 */

import { GridState } from '../types';
import { IEEE_14_BUS_RAW_DATA } from '../cases/ieee14bus';
import { loadPSSESystem } from '../psse/psseLoader';
import { IEEE_9_BUS_RAW_DATA } from '../cases/ieee9bus';

/**
 * Load IEEE 14-bus system for browser environment
 */
export function getIEEE14SystemBrowser(): GridState {
  try {
    // Use the imported raw data directly - esbuild handles the .raw import
    return loadPSSESystem(IEEE_14_BUS_RAW_DATA);
  } catch (error) {
    console.error('Failed to load IEEE 14-bus system in browser:', error);
    // Fallback to empty system
    return { nodes: [], edges: [] };
  }
}

export function getIEEE9SystemBrowser(): GridState {
  try {
    // Use the imported raw data directly - esbuild handles the .raw import
    return loadPSSESystem(IEEE_9_BUS_RAW_DATA);
  } catch (error) {
    console.error('Failed to load IEEE 14-bus system in browser:', error);
    // Fallback to empty system
    return { nodes: [], edges: [] };
  }
}
